var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFHanche3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 178,
    viewBox: "0 0 125 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.098 0.0991211C106.038 20.1493 93.7685 52.4081 102.37 70.1736C110.971 87.939 113.963 88.5013 114.53 111.294C115.097 134.087 110.112 148.996 108.362 177.099",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.572 72.0044C111.572 72.0044 129.467 95.95 121.455 136.181",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9042 0.0991211C17.9644 20.1493 30.2339 52.4081 21.6327 70.1736C13.0316 87.939 10.0396 88.5013 9.47243 111.294C8.90523 134.087 13.8907 148.996 15.6404 177.099",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4307 72.0044C12.4307 72.0044 -5.46412 95.95 2.54704 136.181",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFHanche3);
export default __webpack_public_path__ + "static/media/F-HANCHE_3.8f13fa0f611f85bf72988c786e5d3784.svg";
export { ForwardRef as ReactComponent };